// eslint-disable-next-line import/prefer-default-export
export const removeEndingSlash = path =>
  path.substring(path.length - 1, path.length) === '/'
    ? path.substring(0, path.length - 1)
    : path;

export const getLink = link =>
  link.startsWith('http') ? link : `http://${link}`;

export const isAbsoluteLink = link =>
  /^http(s)?:\/\//.test(link) || /mailto:([^?]*)/.test(link);

/**
 * @param {*} base -> base url string
 * @param {*} name -> name of the query param
 * @param {*} value -> value of the query param
 * @returns -> url string that has query params
 */
export const addUrlParam = (base, name, value) => {
  if (!name || value == null) return base;

  const joiner = base.indexOf('?') === -1 ? '?' : '&';
  const key = encodeURIComponent(name);
  const val = encodeURIComponent(value);

  return `${base}${joiner}${key}=${val}`;
};

/**
 * @param {string} base -> base of the url
 * @param {Object<{name, value}>} params -> key-value pairs of query params that's being added
 * @returns -> url string with query params
 */
export const addUrlParams = (base, params = {}) =>
  Object.entries(params).reduce(
    (result, [name, value]) => addUrlParam(result, name, value),
    base,
  );
